module.exports = __webpack_public_path__ + "fonts/b1ba561e2c246c1a1221e5a2af02b870.woff2";